// Dependencies
import React, { useEffect, useState, useMemo } from "react";

// Modules
import { useSelector } from "react-redux";

// App
import { apiEndpoints } from "../../config";
import MediaLibrary from "../../partials/mediaLibrary";
import { get_csrf_token } from "../../core/auth";

import { Button } from "@mui/material";

import PostEdit from "../../partials/posts/postEdit";

export default function GalleryEdit() {
  const [post, setPost] = useState(null);
  const [showMediaLibrary, setShowMediaLibrary] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState(null);
  const [csrf_token, setCsrfToken] = useState(null);
  const user = useSelector((state) => state.authReducer.user);

  useEffect(() => {
    get_csrf_token().then((response) => setCsrfToken(response.data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //   const extraFields = useMemo(
  //     () => (videoMid ? { field_video: videoMid } : {}),
  //     [videoMid],
  //   );

  return (
    <PostEdit
      apiEndpoint={apiEndpoints.gallery}
      screenClassName={"gallery"}
      categoryTitle={"Gallery category"}
      categoryName={"field_gallery_category"}
      targetVid={"gallery_categories"}
      returnRoute={"/galleries-creator"}
      backBtnText={"Galleries Library"}
      previewRoute={"/galleries/preview"}
      logCustomEventType={"Gallery"}
      //   extraFields={extraFields}
      featuredImageEnabled={true}
      editorProps={{ galleryBlockEnabled: true }}
      setEntityPost={(_post) => {
        setPost(_post);
      }}
    >
    </PostEdit>
  );
}
